export default "assets/images/bg-papier-adcb802b.jpg";